import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface PageSEO {
  meta_title: string | null;
  meta_description: string | null;
  meta_keywords: string | null;
  og_title: string | null;
  og_description: string | null;
  og_image: string | null;
  canonical_url: string | null;
  noindex: boolean | null;
  nofollow: boolean | null;
  schema_type: string | null;
  custom_schema: any;
}

/**
 * Fetches SEO settings from the database for a given page path.
 * Falls back to provided defaults if no DB record exists.
 */
export function usePageSEO(pagePath: string) {
  return useQuery({
    queryKey: ['page-seo', pagePath],
    queryFn: async (): Promise<PageSEO | null> => {
      const { data, error } = await supabase
        .from('page_seo_settings')
        .select('meta_title, meta_description, meta_keywords, og_title, og_description, og_image, canonical_url, noindex, nofollow, schema_type, custom_schema')
        .eq('page_path', pagePath)
        .maybeSingle();

      if (error) {
        console.error('Error fetching page SEO:', error);
        return null;
      }
      return data;
    },
    staleTime: 1000 * 60 * 10, // 10 minutes
  });
}
